class Citation {

    constructor(element) {
        this.isMobile = false;
        this.element = element;
        this.menu = this.element.querySelector(".citation-menu");
        this.menuItems = this.menu.querySelectorAll("li a");
        this.track = this.element.querySelector(".citation-slider__track");
        this.items = this.element.querySelectorAll(".citation-item");
        this.backToMenuButton = this.element.querySelector(".citation-slider__back-to-menu");

        this.init();
    }

    init() {

        if (this.backToMenuButton) {
            this.backToMenuButton.addEventListener("click", (e) => {
                e.preventDefault();
                window.scrollTo({
                    top: this.menu.getBoundingClientRect().top + document.documentElement.scrollTop - 78,
                    behavior: "smooth"
                });
            });
        }

        this.menuItems.forEach(menuItem => {
            menuItem.addEventListener("click", (e) => {
                e.preventDefault();
                const targetItem = this.track.querySelector(e.currentTarget.getAttribute("href"));
                if (targetItem) {
                    this.setActiveMenuItem(e.currentTarget);

                    this.track.scrollTo({
                        left: targetItem.offsetLeft,
                        behavior: "smooth"
                    });

                    if (this.isMobile) {
                        window.scrollTo({
                            top: this.track.getBoundingClientRect().top + document.documentElement.scrollTop - 78,
                            behavior: "smooth"
                        });
                    }

                }
            });
        });
        this.track.addEventListener('scroll', () => {
            const currentItem = this.findCurrentItem();
            if (currentItem) {
                const currentMenuItem = this.menu.querySelector(`[href="#${currentItem.id}"]`);
                setTimeout(() => this.setActiveMenuItem(currentMenuItem), 0);
            }
        }, {passive: true});

        window.addEventListener('resize', () => {
            this.isMobile = this.checkIsMobile();
        });

        this.isMobile = this.checkIsMobile();

        const initiallyActiveItem = this.findCurrentItem();

        if (initiallyActiveItem) {
            const initiallyActiveMenuItem = this.menu.querySelector(`[href="#${initiallyActiveItem.id}"]`);
            this.setActiveMenuItem(initiallyActiveMenuItem);
        }
    }

    setActiveMenuItem(item) {
        [...this.menuItems].forEach(i => {
            if (i === item) {
                i.classList.add("active");
            } else {
                i.classList.remove("active");
                i.blur();
            }
        });
    }

    findCurrentItem() {
        let currentItem = null;
        this.items.forEach(item => {
            const rect = item.getBoundingClientRect();
            const trackRect = this.track.getBoundingClientRect();
            const itemWidth = rect.width;
            const visibleWidth = Math.min(rect.right, trackRect.right) - Math.max(rect.left, trackRect.left);
            if (visibleWidth >= itemWidth / 2) {
                currentItem = item;
            }
        });

        return currentItem;
    }

    checkIsMobile() {
        return window.matchMedia("(max-width: 767px)").matches;
    }

}

const citationNodes = document.querySelectorAll(".citation-slider");
const citations = [];
[...citationNodes].forEach(element => {
    citations.push(new Citation(element));
});
